import React, { useState, useEffect } from "react";
import { request, gql } from "graphql-request";
import PageHeader from "../components/PageHeader";
import { hyGraphToken, endpointURL } from "../ThemeModule";
import Sidebar from "./blog/Sidebar";
import "./blog/blog.scss";
import BlogArticle from "./blog/BlogArticle";
import Seo from "../components/Seo";
import { ROUTE_META, SITE_URL, breadcrumbSchema } from "../seo/siteMeta.mjs";

const blogSchema = [
  {
    "@type": "Blog",
    name: ROUTE_META["/blog"].title,
    description: ROUTE_META["/blog"].description,
    url: `${SITE_URL}/blog`,
    publisher: { "@id": `${SITE_URL}/#organization` },
  },
  breadcrumbSchema([
    { name: "Home", path: "/" },
    { name: "Blog", path: "/blog" },
  ]),
];
const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      const endpoint = endpointURL;
      const query = gql`
        query{
          postsConnection {
            edges {
              node {                
                categories {
                  title
                  slug
                }
                title
                slug
                publishedAt
                featuredPost
                featureImage {
                  url
                }
              }
            }
          }
         
        }
      `;
      const headers = {
        Authorization: `Bearer ${hyGraphToken}`,
      };

      try {
        const data = await request(endpoint, query, {}, headers);
        setPosts(data.postsConnection.edges);
      } catch (error) {
        console.error("Error fetching posts:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  

  return (
    <>
      <Seo
        path="/blog"
        title={ROUTE_META["/blog"].title}
        description={ROUTE_META["/blog"].description}
        schema={blogSchema}
      />

      <PageHeader title="Latest Blog" />
      <section className="blog page-section relative shape-1 shape-2">
        <div className="max-w-container mx-auto px-4">
          <div className=" flex-wrap flex justify-left  -mx-6">
            <div className="w-full md:w-8/12 px-6">
              {loading ? (
                <div className="loader">Loading...</div>
              ) : error ? (
                <div className="error-message">
                  <p>Failed to load posts: {error}</p>
                </div>
              ) : (
                <div className="postGrid_box">
                  {posts.map(({ node }) => (
                    <BlogArticle key={node.title} node={node} />
                  ))}
                </div>
              )}
            </div>

            <div className="w-full md:w-4/12 px-6">
              <Sidebar  />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
